<template>
  <div id="main">
    <div id="index">
      <h2>통합플랫폼 베타버전</h2><br>
      <h3><a :href="android_url">Android 앱 다운받기</a></h3><br>
      <h3><a :href="ios_url">iOS 앱 다운받기</a></h3>
    </div>
  </div>
</template>

<script>
export default {
  name: "download",

  data: () => ({
    android_url: 'https://drive.google.com/file/d/1-nJFW77Yrjbn-MtjVSdhurR9PjA4BKHO/view?usp=sharing',
    ios_url: 'itms-services://?action=download-manifest&url=https://dl.dropboxusercontent.com/s/mwegkc4kgltumq7/carrotfarm.plist'
  }),
}
</script>

<style scoped>

#index {
  text-align: center;
  margin-top: 50px;
}

</style>
